import { ReactElement, lazy, useEffect, useState } from 'react'

import { Loader } from '../components/Loader'
import { getVerifiedCredentialsUserEmail } from '../services/api/auth'
import { environmentVariables } from '../utils/environmentVariables'
import { ErrorCodes } from '../utils/errors'
import { redirectToUrl } from '../utils/location'
import { QueryParameters } from '../utils/queryParameters'

export const LazyChangeEmailPage = lazy(() =>
  import('../pages/ChangeEmailPage').then((module) => ({
    default: module.ChangeEmailPage,
  })),
)

export const ChangeEmailRoute = (): ReactElement => {
  const [hasUserVerifiedCredentials, setHasUserVerifiedCredentials] = useState(false)

  useEffect(() => {
    getUserEmail()
  }, [])

  const getUserEmail = async (): Promise<void> => {
    try {
      await getVerifiedCredentialsUserEmail()
      setHasUserVerifiedCredentials(true)
    } catch (error) {
      console.log(error)
      // If the response from getVerifiedCredentialsUserEmail is not a 200, the user has not verified his credentials.
      const query = `${QueryParameters.ERROR_CODE}=${ErrorCodes.EXPIRED_SESSION}`
      redirectToUrl(`${environmentVariables('AUTH_API_URL')}/signin?${query}`)
    }
  }

  if (hasUserVerifiedCredentials) {
    return <LazyChangeEmailPage />
  }

  return <Loader />
}
